import fetch from "../../uilts/request.js";


export default {

  zhiMiQuery(data) {
    return fetch.post('/BigData/zhiMiQuery', data)
  },
  diTingQuery(data) {
    return fetch.post('/BigData/diTingQuery', data)
  },
  createBoolTemp(data) {
    return fetch.post('/BigData/createBoolTemp', data)
  },
  previewFileId3(data) {
    return fetch.post('/BigData/previewFileId3', data)
  },
  downFileId3(data) {
    return fetch.post('/BigData/downFileId3', data)
  },
  createZuWuTemp(data) {
    return fetch.post('/BigData/createZuWuTemp', data)
  },
  previewFileId22(data) {
    return fetch.post('/BigData/previewFileId22', data)
  },
  downFileId22(data) {
    return fetch.post('/BigData/downFileId22', data)
  },
  queryZuWu(data) {
    return fetch.post('/BigData/queryZuWu', data)
  },
  gaoJi(data) {
    return fetch.post('/BigData/gaoJi', data)
  },

}
